// When the owner's farm may reload on someone else's change (farm 5: a friend's help): only with
// nothing unsent, nothing in flight and no job running — else after the next flush.
export const refreshNow = ({ pending, flushing, job }) => pending === 0 && !flushing && !job;
